"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitWithLimit = void 0;
var tslib_1 = require("tslib");
function splitWithLimit(str, delim, count) {
    var parts = str.split(delim);
    if (parts.length <= count) {
        return parts;
    }
    return tslib_1.__spread(parts.slice(0, count - 1), [parts.slice(count - 1).join(delim)]);
}
exports.splitWithLimit = splitWithLimit;
//# sourceMappingURL=splitWithLimit.js.map